import {useLocation} from "react-router";

export function useGlQueryParam () {

    const countryCode = useLocation().search.split("=")[1];

    let emailSuffix = countryCode;

    if(!emailSuffix) {
        emailSuffix = "de";
    }
    emailSuffix = emailSuffix.toLocaleLowerCase();

    return {
        emailSuffix,
        countryCode
    };
}
